// console.log("script runnn");

(async function () {
  const script =
    document.currentScript ||
    document.querySelector('script[src*="trc-hero-dd.js"]');

  if (!script) return;

  // URLs
  const pcMakeModelUrl = script.dataset.pcMakemodel;
  const prioritizedMakesUrl = script.dataset.prioritizedMakes;
  const prioritizedModelsUrl = script.dataset.prioritizedModels;
  const ftMarketUrl = script.dataset.ftMarket;

  // DOM
  const parent = document.getElementById("vs-parent");
  const trigger = document.getElementById("vs-trigger");
  const triggerSelection = document.getElementById("vs-trigger-selection");
  const panel = document.getElementById("vs-make-panel");

  const compatWrap = document.getElementById("vs-compat");
  const compatPC = document.getElementById("vs-compat-pc");
  const compatFT = document.getElementById("vs-compat-ft");
  const compatPCBtn = document.getElementById("vs-compat-pc-btn");
  const compatFTBtn = document.getElementById("vs-compat-ft-btn");

  const nav = document.getElementById("vs-nav");
  const backGlobal = document.getElementById("vs-back-global");

  const trcHeroWrap = document.querySelector(".trc-hero__wrap");

  if (!parent || !trigger || !panel || !triggerSelection) return;
  if (!compatWrap || !compatPC || !compatFT || !compatPCBtn || !compatFTBtn) return;
  if (!nav || !backGlobal) return;

  /* ---------------- helpers ---------------- */

  const STORAGE_NAMESPACE = "trcHero";

  const fetchJson = async (url) => {
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Fetch failed (${res.status}): ${url}`);
    return res.json();
  };

  const norm = (s) => (s || "").toString().trim().toLowerCase();
  const encodeQS = (s) => encodeURIComponent((s || "").toString().trim());

  const getStorageKey = (key, url) => `${STORAGE_NAMESPACE}:${key}:${url}`;

  const clearOldVersions = (key, currentUrl) => {
    try {
      const prefix = `${STORAGE_NAMESPACE}:${key}:`;

      for (let i = localStorage.length - 1; i >= 0; i--) {
        const storageKey = localStorage.key(i);
        if (!storageKey) continue;
        if (!storageKey.startsWith(prefix)) continue;
        if (storageKey === getStorageKey(key, currentUrl)) continue;

        localStorage.removeItem(storageKey);
      }
    } catch {}
  };

  const getFromStorage = (key, url) => {
    try {
      const raw = localStorage.getItem(getStorageKey(key, url));
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  };

  const saveToStorage = (key, url, data) => {
    try {
      clearOldVersions(key, url);
      localStorage.setItem(getStorageKey(key, url), JSON.stringify(data));
    } catch {}
  };

  const getData = async (key, url) => {
    const cached = getFromStorage(key, url);
    if (cached && Array.isArray(cached)) return cached;

    const data = await fetchJson(url);

    if (Array.isArray(data)) {
      saveToStorage(key, url, data);
    }

    return data;
  };

  const uniq = (arr) => {
    const seen = new Set();
    return arr.filter((x) => {
      const k = norm(x);
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  };

  const buildPCUrl = (make, model) =>
    `products/pedal-commander?make=${encodeQS(make)}&model=${encodeQS(model)}`;

  const buildFTUrl = (make, model) =>
    `products/fn-tuned?make=${encodeQS(make)}&model=${encodeQS(model)}`;

  const setSelectionText = (make, model) => {
    if (!make && !model) triggerSelection.textContent = "";
    else if (make && !model) triggerSelection.textContent = make;
    else triggerSelection.textContent = `${make} / ${model}`;
  };

  const openPanel = () => {
    panel.hidden = false;
    trigger.setAttribute("aria-expanded", "true");
    if (trcHeroWrap) trcHeroWrap.style.alignItems = "flex-start";
    scrollToElement(trigger, 100);
  };

  const closePanel = () => {
    panel.hidden = true;
    trigger.setAttribute("aria-expanded", "false");
    if (trcHeroWrap) trcHeroWrap.style.alignItems = "center";
  };

  const showLoading = () => {
    panel.innerHTML = `
      <div class="trc-dd__panel-inner">
        <div class="trc-dd__loading">Loading...</div>
      </div>
    `;
  };

  const stripMakePrefix = (make, modelFull) => {
    const mf = (modelFull || "").trim();
    const mk = (make || "").trim();
    if (!mf || !mk) return mf;

    const lowerMf = mf.toLowerCase();
    const lowerMk = mk.toLowerCase();
    if (lowerMf.startsWith(lowerMk + " ")) return mf.slice(mk.length).trim();
    return mf;
  };

  const hideCompat = () => {
    compatWrap.hidden = true;
    compatPC.hidden = true;
    compatFT.hidden = true;
    compatPCBtn.href = "#";
    compatFTBtn.href = "#";
  };

  const showCompatBoth = ({ make, model }) => {
    compatWrap.hidden = false;
    compatPC.hidden = false;
    compatFT.hidden = false;
    compatPCBtn.href = buildPCUrl(make, model);
    compatFTBtn.href = buildFTUrl(make, model);
  };

  function scrollToElement(targetEl, offset = 0) {
    if (!targetEl) return;

    const elementTop =
      targetEl.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: elementTop - offset,
      behavior: "smooth"
    });
  }

  /* ---------------- state ---------------- */

  const state = {
    view: "makes", // "makes" | "models"
    selectedMake: "",
    selectedModel: "",
    ftMarket: null,
  };

  const updateNav = () => {
    const onMakes = state.view === "makes" && compatWrap.hidden;

    if (onMakes) {
      nav.hidden = true;
      return;
    }

    nav.hidden = false;
    backGlobal.textContent = compatWrap.hidden ? "← Back" : "← Change vehicle";
  };

  /* ---------------- load initial data ---------------- */

  let pcMakeModel = [];
  let prioritizedMakes = [];
  let prioritizedModels = [];

  try {
    [pcMakeModel, prioritizedMakes, prioritizedModels] = await Promise.all([
      getData("pcMakeModel", pcMakeModelUrl),
      getData("prioritizedMakes", prioritizedMakesUrl),
      getData("prioritizedModels", prioritizedModelsUrl),
    ]);
  } catch (e) {
    console.error(e);
    panel.innerHTML = `
      <div class="trc-dd__panel-inner">
        <div class="trc-dd__loading">Error loading data.</div>
      </div>
    `;
    return;
  }

  /* ---------------- render ---------------- */

  const renderShell = () => `
    <div class="trc-dd__panel-inner">
      <div class="trc-dd__body" id="vs-panel-body"></div>
    </div>
  `;

  const renderGroup = (title, items, itemClass, dataAttrsBuilder) => {
    if (!items.length) return "";

    const lis = items
      .map((label) => {
        const attrs = dataAttrsBuilder ? dataAttrsBuilder(label) : "";
        return `
          <li class="trc-dd__item ${itemClass}" ${attrs}>
            <span>${label}</span>
          </li>
        `;
      })
      .join("");

    return `
      <div class="trc-dd__group-title">${title}</div>
      <ul class="trc-dd__list">${lis}</ul>
    `;
  };

  const renderMakesView = () => {
    state.view = "makes";
    state.selectedMake = "";
    state.selectedModel = "";

    hideCompat();
    setSelectionText("", "");

    const allMakes = pcMakeModel.map((x) => x.make).filter(Boolean);
    const prioritizedSet = new Set(prioritizedMakes.map(norm));

    const best = [];
    const other = [];

    allMakes.forEach((make) => {
      if (prioritizedSet.has(norm(make))) best.push(make);
      else other.push(make);
    });

    const bestUniq = uniq(best);
    const otherUniq = uniq(other).sort((a, b) => a.localeCompare(b));

    panel.innerHTML = renderShell();
    const body = panel.querySelector("#vs-panel-body");

    body.innerHTML =
      renderGroup(
        "Best sellers",
        bestUniq,
        "vs-make-item",
        (m) => `data-make="${String(m).replace(/"/g, "&quot;")}"`
      ) +
      renderGroup(
        "Other makes",
        otherUniq,
        "vs-make-item",
        (m) => `data-make="${String(m).replace(/"/g, "&quot;")}"`
      );

    updateNav();
  };

  const renderModelsView = (make) => {
    state.view = "models";
    state.selectedMake = make;
    state.selectedModel = "";

    hideCompat();
    setSelectionText(make, "");

    const makeObj = pcMakeModel.find((x) => norm(x.make) === norm(make));
    const modelsFull = (makeObj?.models || []).filter(Boolean);

    const models = modelsFull.map((full) => {
      const short = stripMakePrefix(make, full);
      return { full, short, label: short || full };
    });

    const best = [];
    const other = [];

    models.forEach((m) => {
      const isBest = prioritizedModels.some((p) => {
        const pn = norm(p);
        return pn === norm(m.full) || pn.includes(norm(m.label));
      });

      if (isBest) best.push(m);
      else other.push(m);
    });

    const bestUniq = uniq(best.map((x) => x.label)).map((label) =>
      best.find((x) => x.label === label)
    );

    const otherUniq = uniq(other.map((x) => x.label))
      .map((label) => other.find((x) => x.label === label))
      .sort((a, b) => a.label.localeCompare(b.label));

    panel.innerHTML = renderShell();
    const body = panel.querySelector("#vs-panel-body");

    const buildAttrs = (obj) => `
      data-make="${String(make).replace(/"/g, "&quot;")}"
      data-model-short="${String(obj.short).replace(/"/g, "&quot;")}"
      data-model-full="${String(obj.full).replace(/"/g, "&quot;")}"
    `;

    body.innerHTML =
      renderGroup(
        "Best sellers",
        bestUniq.map((x) => x.label),
        "vs-model-item",
        (label) => buildAttrs(bestUniq.find((x) => x.label === label))
      ) +
      renderGroup(
        "Other models",
        otherUniq.map((x) => x.label),
        "vs-model-item",
        (label) => buildAttrs(otherUniq.find((x) => x.label === label))
      );

    updateNav();
  };

  const modelExistsInFt = (make, modelShortOrLabel) => {
    if (!state.ftMarket || !Array.isArray(state.ftMarket)) return false;

    const makeObj = state.ftMarket.find((x) => norm(x.make) === norm(make));
    if (!makeObj || !Array.isArray(makeObj.models)) return false;

    return makeObj.models.some((m) => norm(m.model) === norm(modelShortOrLabel));
  };

  /* ---------------- init ---------------- */

  renderMakesView();
  hideCompat();
  updateNav();

  /* ---------------- global back/change ---------------- */

  backGlobal.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!compatWrap.hidden) {
      hideCompat();

      if (state.selectedMake) renderModelsView(state.selectedMake);
      else renderMakesView();

      openPanel();
      return;
    }

    if (state.view === "models") {
      renderMakesView();
      openPanel();
    }
  });

  /* ---------------- open/close ---------------- */

  parent.addEventListener("click", (e) => e.stopPropagation());

  trigger.addEventListener("click", (e) => {
    e.preventDefault();
    panel.hidden ? openPanel() : closePanel();
  });

  document.addEventListener("click", () => closePanel());

  /* ---------------- interaction ---------------- */

  panel.addEventListener("click", async (e) => {
    const makeItem = e.target.closest(".vs-make-item");
    if (makeItem) {
      const make = makeItem.dataset.make;
      showLoading();

      try {
        if (!state.ftMarket) {
          state.ftMarket = await getData("ftMarket", ftMarketUrl);
        }
      } catch (err) {
        console.error(err);
        panel.innerHTML = `
          <div class="trc-dd__panel-inner">
            <div class="trc-dd__loading">Error loading data.</div>
          </div>
        `;
        return;
      }

      renderModelsView(make);
      openPanel();
      return;
    }

    const modelItem = e.target.closest(".vs-model-item");
    if (modelItem) {
      const make = modelItem.dataset.make;
      const modelShort = modelItem.dataset.modelShort || "";
      const modelFull = modelItem.dataset.modelFull || "";
      const modelLabel = modelShort || modelFull;

      state.selectedMake = make;
      state.selectedModel = modelLabel;
      setSelectionText(make, modelLabel);

      const inFt = modelExistsInFt(make, modelShort || modelLabel);

      if (inFt) {
        showCompatBoth({ make, model: modelLabel });
        closePanel();
        updateNav();
      } else {
        window.location.href = buildPCUrl(make, modelLabel);
      }

      return;
    }
  });
})();